import { Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CamService } from 'src/app/services/camService/cam.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { map, Observable, startWith, Subject, takeUntil } from 'rxjs';
import { MatChipInputEvent, MatChipGrid, MatChipRow, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ApiResponse, CamDeleteModel } from 'src/app/models/interface/CAM/baseResponseInterfaces';
import { Branch, CostCenter, CostCenterRequest } from 'src/app/models/interface/CAM/CompanyProfileInterface';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { NgIf, NgFor, NgClass, AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatError, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatAutocompleteTrigger, MatAutocomplete, MatOption } from '@angular/material/autocomplete';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { CamEmptyStateComponent } from '../cam-empty-state/cam-empty-state.component';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
    selector: 'app-cost-center-overview',
    templateUrl: './cost-center-overview.component.html',
    styleUrls: ['./cost-center-overview.component.scss'],
    imports: [ReactiveFormsModule, NgIf, MatIcon, MatFormField, MatLabel, MatInput, MatError, MatRadioGroup, MatRadioButton, MatChipGrid, NgFor, MatChipRow, MatChipRemove, MatChipInput, MatAutocompleteTrigger, MatSuffix, NgClass, MatAutocomplete, MatOption, MatCheckbox, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, CamEmptyStateComponent, CdkScrollable, MatDialogContent, MatDialogActions, AsyncPipe]
})
export class CostCenterOverviewComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['Cost Center Name', 'Cost Center Code', 'Status', 'Actions'];
  // dataSource = ELEMENT_DATA;
  Addnew: boolean = false;
  costCenterForm: FormGroup | any
  branchList: any[] = []
  isEdit: boolean = false;
  isLoading = true; // Start loading state
  selectedBranchIdsMap: { [key: number]: boolean } = {}; // Track selected branch IDs

  commomObjPipe: any = {
    costCentreDetails: { pipe: [] as CostCenter[], all: [] as CostCenter[] },
  }

  @ViewChild('selectionWarning') selectionWarning!: TemplateRef<any>;
  currentItem: any;
  noRecordFound: boolean = false;


  separatorKeysCodes: number[] = [ENTER, COMMA];
  associateWithBranch = new FormControl('');
  filteredBranch: Observable<any[]>;
  BranchName: string[] = [];
  // allFruits: string[] = ['Apple', 'Lemon', 'Lime', 'Orange', 'Strawberry'];
  announcer: any;

  @ViewChild('fruitInput') fruitInput!: ElementRef<HTMLInputElement>;
  private destroy$ = new Subject<void>();
  content: any;
  dictionaryContent:any;
  constructor(private fb: FormBuilder, private _camService: CamService, private dialog: MatDialog, private _ToastrApiService: ToastrApiService, private _CommonService: CommonService, private _CompanyManagementService: CompanyManagementService, private contentService: CompanyManagementContentService,private readonly dictionaryContentService:DisctionaryContent) {
    this.costCenterForm = this.fb.group({
      flag: 'ADD',
      costCenterId: null,
      costCenterName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100)]],
      costCenterCode: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(20)]],
      status: [true],
      associateWithBranch: ['', [Validators.required]]
    })



    // this.filteredBranch = this.associateWithBranch.valueChanges.pipe(
    //   startWith(null),
    //   map((fruit: string | null) => (fruit ? this._filter(fruit) : this.branchList.slice())),
    // );

    this.filteredBranch = this.associateWithBranch.valueChanges.pipe(
      startWith(null),
      map((value: string | null) => {
        if (typeof value === 'string') {
          return this._filter(value);
        } else {
          return this.branchList.slice();
        }
      })
    );


  }

  ngOnInit(): void {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.content = res;
    });
    this.dictionaryContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.dictionaryContent = res;
    });
    this.getCostCenterOverviewList()
    this.getBranchInfoList()

  }

  // Fetch branch list dynamically
  getBranchInfoList() {
    this._camService.GetBranchInformation().then((res: ApiResponse<Branch[]>) => {
      if (res?.status == 'Success') {

        this.branchList = res.data.filter(($branch: Branch) => !!$branch.status)?.map((branch: { corpBranchName: string, corpBranchId: number }) => ({
          name: branch.corpBranchName, // Display Name
          id: branch.corpBranchId  // Unique ID for Storage
        }));
      } else {
        this.branchList = [];
      }

    })
      .catch((err) => {
        const errMsg = err?.message || err?.error?.message || 'Something went wrong while fetching Branch Inforation List.';
        this._CompanyManagementService.view_error_message(errMsg,err?.code)
        this._ToastrApiService.show('error', errMsg)
        console.error("Error fetching branch information:", err);
        this.branchList = [];
      });
  }


  // Modify the filter method to filter branch names
  // private _filter(value: string): any[] {

  //   const filterValue = value.toLowerCase();
  //   return this.branchList.filter(branch => branch.name.toLowerCase().includes(filterValue));
  // }

  private _filter(value: string): any[] {

    const filterValue = value.toLowerCase();
    const filteredData = this.branchList.filter(branch => branch.name.toLowerCase().includes(filterValue));
    this.noRecordFound = (filteredData.length === 0);
    return filteredData
  }


  // Handle checkbox selection
  onCheckboxChange(event: any, branch: any, parentClass: string, matAutoClassRef: string) {

    this.selectedBranchIdsMap[branch.id] = event.checked; // Update the map
    if (event.checked) {

      if (!this.BranchName.includes(branch.name)) {
        this.BranchName.push(branch.name);
      }
    } else {
      this.BranchName = this.BranchName.filter(name => name !== branch.name);
    }

    const selectedBranchIds = Object.keys(this.selectedBranchIdsMap)
      .filter(key => this.selectedBranchIdsMap[parseInt(key)])
      .map(key => parseInt(key));


    this.costCenterForm.controls['associateWithBranch'].setValue(selectedBranchIds.join(','));
    this.costCenterForm.controls['associateWithBranch'].updateValueAndValidity();

    requestAnimationFrame(() => this.CustomMatAutoPosition(parentClass, matAutoClassRef));
  }

  CustomMatAutoPosition(parentClass: string, matAutoClassRef: string) {
    let parent = (document.querySelector(`.${parentClass}`) as HTMLDivElement).getBoundingClientRect();
    (document.querySelector('.cdk-overlay-connected-position-bounding-box .cdk-overlay-pane') as HTMLDivElement)?.style.setProperty('top', `${parent.top + parent.height}px`, 'important');
    // (document.querySelector(`.${matAutoClassRef}`) as HTMLDivElement).style.marginTop = `${parent.top + parent.height}px`;
  }


  handleEvent(event: string) {
    if (event.includes('cost-center-overview')) {
      //  GTM service call
      this._CompanyManagementService.costcenter_click( 'Add link','Add', this.commomObjPipe.costCentreDetails.pipe.length );
      this.Addnew = true;
      this.costCenterForm.reset({
        flag: 'ADD',
        costCenterId: null,
        status: true,
        costCenterName: '',
        costCenterCode: ''
      })
      this.selectedBranchIdsMap = {};
      this.BranchName = [];
    }
  }

  addNewCostCenter() {
    this.Addnew = true;
    this.isEdit = false;
    this.costCenterForm.reset({
      flag: 'ADD',
      costCenterId: null,
      status: true,
      costCenterName: '',
      costCenterCode: ''
    })
    this.selectedBranchIdsMap = {};
    this.BranchName = [];

    this._CompanyManagementService.costcenter_click('Add link','Add', this.commomObjPipe.costCentreDetails.pipe.length)// GTM use
  }
  onCancel() {
    this.Addnew = false;
    this._CompanyManagementService.costcenter_click('Cancel button','Cancel', this.commomObjPipe.costCentreDetails.pipe.length)// GTM use

  }

  getCostCenterOverviewList() {
    this.isLoading = true
    this._camService.getCostCenterOverview().then((res: ApiResponse<CostCenter[]>) => {
      if (res.status == "Success") {
        this.bindList('costCentreDetails', res.data);
      }else{
        this.bindList('costCentreDetails', []);
      }
    }).catch((error) => {
      console.error(error)
       const message =
          error?.error?.message ||
          error?.message ||
          'Something went wrong. Please try again.';
      this._CompanyManagementService.view_error_message(message,error?.code);
      this.bindList('costCentreDetails', []);
    }).finally(() => {
      this.isLoading = false;
    })
  }

  bindList(key: any, list: any[]) {
    this.commomObjPipe[key].pipe = list;
    this.commomObjPipe[key].all = list;
  }



  onSave() {

    this._CompanyManagementService.costcenter_click('Save button','Save', this.commomObjPipe.costCentreDetails.pipe.length)// GTM use


    if (this.costCenterForm.invalid) {
      return;
    }

    const requestData: CostCenterRequest = {
      flag: this.costCenterForm?.value.flag,
      costCenterId: this.costCenterForm.value.costCenterId,
      costCenterName: this.costCenterForm.value.costCenterName,
      costCenterCode: this.costCenterForm.value.costCenterCode,
      status: this.costCenterForm.value.status,
      associateWithBranch: this.costCenterForm.value.associateWithBranch,
    };

    this._camService.insertUpdateCostCenterOverviewV1(requestData)
      .then((res: any) => {
        if (!res) {
          this._ToastrApiService.show('error', 'No response received from server.');
          return;
        }

        // Handle API response
        switch (res.status) {
          case 'Created':
            this._ToastrApiService.show('success', res.message || 'Cost Center created successfully.');
            this._CompanyManagementService.save_success('Cost center overview', 'Success')//GTM use

            break;

          case 'Success':
            this._ToastrApiService.show('success', res.message || 'Cost Center updated successfully.');
            this._CompanyManagementService.save_success('Cost center overview', 'Success')//GTM use

            break;

          case 'Conflict':
            this._ToastrApiService.show('warning', res.message || 'Duplicate entry detected.');
            break;

          default:
            this._ToastrApiService.show('error', res.message || 'Unexpected response from server.');
            console.warn('Unhandled status:', res);
            break;
        }

        // Refresh list and reset form
        this.getCostCenterOverviewList();
        this.Addnew = false;
        this._CommonService.formResetTrigger();// Rereder the component

        this.costCenterForm.reset({
          flag: 'ADD',
          costCenterId: null,
          costCenterName: '',
          costCenterCode: '',
          status: true,
          associateWithBranch: '',
        });

        this.costCenterForm.markAsPristine();
        this.costCenterForm.markAsUntouched();
      })
      .catch((error: any) => {
        console.error('Error saving cost center:', error);

        const errorMessage =
          error?.error?.message ||
          error?.message ||
          'Something went wrong while saving the cost center. Please try again later.';
        this._CompanyManagementService.view_error_message(errorMessage,error?.code);
        this._ToastrApiService.show('error', errorMessage);
      });
  }





  onEdit(item: CostCenter) {
    this._CompanyManagementService.costcenter_click('Edit button','Edit', this.commomObjPipe.costCentreDetails.pipe.length)// GTM use

    // Convert AssociatedWithBranch_Id (comma-separated string) into an array of numbers
    const associatedBranchIds = item.associatedWithBranchId
      ? item.associatedWithBranchId.split(',').map((id: string) => parseInt(id, 10))
      : [];

    this.isEdit = true;
    this.Addnew = true;
    this.costCenterForm.patchValue({
      flag: 'UPDATE',
      costCenterId: item.costCenterId,
      costCenterName: item.costCenterName,
      costCenterCode: item.costCenterCode,
      status: item.status,
      associateWithBranch: associatedBranchIds.join(',')
    });

    // Populate selectedBranchIdsMap and BranchName
    this.selectedBranchIdsMap = {};
    this.BranchName = [];

    associatedBranchIds.forEach((branchId: any) => {
      this.selectedBranchIdsMap[branchId] = true;
      const branch = this.branchList.find(b => b.id === branchId);
      if (branch) {
        this.BranchName.push(branch.name);
      }
    });
  }


  onRemove(item: CostCenter) {
    this._CompanyManagementService.costcenter_click('Remove button','Remove', this.commomObjPipe.costCentreDetails.pipe.length)// GTM use
    this.currentItem = item;
    const dialogRef = this.dialog.open(this.selectionWarning, {
      data: item, // Pass the item data
    });
  }


  confirmDelete(item: CostCenter) {

    const request: CamDeleteModel = {
      id: item.costCenterId,
      type: 'COSTCENTER'
    }

    this._camService.DeleteCAMitemBytype(request).then((res) => {

      if (res.status == "Success") {
        this._ToastrApiService.show('success', res.message);
        this._CompanyManagementService.costcenter_remove_success('success')// GTM use
        this.currentItem = undefined;
        this.getCostCenterOverviewList()
      }
    }).catch((error) => {

      const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while delete the cost center. Please try again later.';
      this._CompanyManagementService.view_error_message(errorMessage,error?.code);
      this._ToastrApiService.show('error', errorMessage);
      this.getCostCenterOverviewList()

    });
  }

  CloseDialog(result: boolean) {
    if (result) {
      this.confirmDelete(this.currentItem)
      this._CompanyManagementService.costCenterOverview_remove('Proceed', 'Are you sure you want to remove this cost center?')//GTM use
    }

    if (!result) {
      this._CompanyManagementService.costCenterOverview_remove('Cancel', 'Are you sure you want to remove this cost center?')//GTM use

    }

    this.dialog.closeAll(); // Closes the dialog
  }



  disableRightClick(event: MouseEvent): void {
    event.preventDefault();
  }

  onPasteBlocked(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent the paste action
  }

  blockInvalidCharacters1(event: KeyboardEvent): void {
    // List of invalid characters that can be used for XSS, SQL injection, or path traversal
    const invalidChars = ['<', '>', '"', "'", '`', ';', ':', '$', '|', '[', ']', '~', '--', '@', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}',];

    // If the pressed key is in the invalidChars array, prevent the input
    if (invalidChars.includes(event.key)) {
      event.preventDefault(); // Block the invalid character
    }
  }


  //new drop down

  add(event: MatChipInputEvent): void {

    const value = (event.value || '').trim();

    if (value) {
      const matchingBranch = this.branchList.find(branch => branch.name.toLowerCase() === value.toLowerCase());

      if (matchingBranch) {
        // Branch found, select it
        this.onCheckboxChange({ checked: true, stopPropagation: () => { } }, matchingBranch, 'custom-mat-dropdown-parent', 'custom-autocomplete');
      }
      else {
      }
    }

    // Clear the input value
    event.chipInput!.clear();

    this.associateWithBranch.setValue(null);
    let parent = (document.querySelector(`.${'custom-mat-dropdown-parent'}`) as HTMLDivElement).getBoundingClientRect();
    (document.querySelector(`.${'custom-autocomplete'}`) as HTMLDivElement).style.marginTop = `${parent.top + parent.height}px`;
  }

  remove(Name: string): void {
    const index = this.BranchName.indexOf(Name);
    if (index >= 0) {
      this.BranchName.splice(index, 1);
      this.announcer?.announce(`Removed ${Name}`);

      const branch = this.branchList.find(b => b.name === Name);
      if (branch) {
        this.selectedBranchIdsMap[branch.id] = false; // Uncheck the checkbox

        const selectedBranchIds = Object.keys(this.selectedBranchIdsMap)
          .filter(key => this.selectedBranchIdsMap[parseInt(key)])
          .map(key => parseInt(key));

        this.costCenterForm.controls['associateWithBranch'].setValue(selectedBranchIds.join(','));
        this.costCenterForm.controls['associateWithBranch'].updateValueAndValidity();
      }
    }
  }

  optionClicked(branch: any) {
    // Toggle the checkbox state
    const newCheckedState = !this.selectedBranchIdsMap[branch.id];

    // Create a mock event object that matches what the checkbox change expects
    const mockEvent = {
      checked: newCheckedState,
      stopPropagation: () => { } // Add empty function to prevent errors
    };

    // Call your existing checkbox handler with the toggled state
    this.onCheckboxChange(mockEvent, branch, 'custom-mat-dropdown-parent', 'custom-autocomplete');
  };
   sitecoreGetWarningMessage(messageId: string): any {
    return this.content?.warningList?.find(
      (item: any) => item.messageID === messageId
    );
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}

